// extracted by mini-css-extract-plugin
export default {"srOnly":"styles_srOnly__ZbEPi"};